/* eslint-disable camelcase */

export function checkName(name) {
    if (!name) return false;
    if (name.length > 0) return true;
    return false;
}

export function checkMessage(message) {
    if (!message) return false;
    if (message.length > 0) return true;
    return false;
}

export function checkEmail(email) {
    if (!email) return false;
    if (email.length > 0) return true;
    return false;
}

export function checkQuestionType(currentQuestionType) {
    if (!currentQuestionType) return false;
    return !!currentQuestionType;
}

export function checkEventType(currentEventType) {
    if (!currentEventType) return false;
    return !!currentEventType;
}

export function supportFormHasErrors({
    name, message, email, currentQuestionType,
}) {
    const errorsList = [];

    if (!checkName(name)) {
        errorsList.push({
            key: 'name',
            message: 'Veuillez renseigner votre nom',
        });
    }

    if (!checkMessage(message)) {
        errorsList.push({
            key: 'message',
            message: 'Veuillez renseigner votre demande',
        });
    }

    if (!checkEmail(email)) {
        errorsList.push({
            key: 'email',
            message: 'Veuillez renseigner une adresse mail valide',
        });
    }

    if (!checkQuestionType(currentQuestionType)) {
        errorsList.push({
            key: 'questionType',
            message: 'Veuillez renseigner le type de question',
        });
    }

    if (errorsList.length <= 0) return false;
    return errorsList;
}

export function salesmanFormHasErrors({
    name, message, currentEventType, email,
}) {
    const errorsList = [];

    if (!checkName(name)) {
        errorsList.push({
            key: 'name',
            message: 'Veuillez renseigner votre nom',
        });
    }

    if (!checkMessage(message)) {
        errorsList.push({
            key: 'message',
            message: 'Veuillez renseigner votre demande',
        });
    }

    if (!checkEmail(email)) {
        errorsList.push({
            key: 'email',
            message: 'Veuillez renseigner une adresse mail valide',
        });
    }

    if (!checkEventType(currentEventType)) {
        errorsList.push({
            key: 'eventType',
            message: 'Veuillez renseigner le type d\'événement',
        });
    }

    if (errorsList.length <= 0) return false;
    return errorsList;
}
